import { POSITION_PRESET } from '@/utils/scans/trackballControls';

export const HOTKEYS = {
  g: 'g',
  r: 'r',
  '1': POSITION_PRESET.FRONT,
  '2': POSITION_PRESET.BACK,
  '3': POSITION_PRESET.LEFT,
  '4': POSITION_PRESET.RIGHT,
  '5': POSITION_PRESET.TOP,
  '6': POSITION_PRESET.BOTTOM,
} as const;
